import { FC } from "react";
import { PrintJobLoadingModal } from "./PrintJobLoadingModal";
import { PrintJobSummaryModal } from "./PrintJobSummaryModal";

export enum ShipToStoreModal {
  LOADING = "LOADING",
  SUMMARY = "SUMMARY",
}

export const shipToStoreModalMap: Record<ShipToStoreModal, FC<any>> = {
  [ShipToStoreModal.LOADING]: PrintJobLoadingModal,
  [ShipToStoreModal.SUMMARY]: PrintJobSummaryModal,
};
